import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBadgeById } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
// import { EventDetailsSchema } from "../../schema";

const ViewBadges = ({ id }) => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.profileReducer);
  const [serviceData, setServiceData] = useState(null);
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const getBadgesManagement = async () => {
    setIsLoading(true);
    getBadgeById(id, token)
      .then((res) => {
        setServiceData(res?.data?.data);
        setIsLoading(false);
        if (res) {
          setServiceData(res?.data?.data);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    async function getAllAPI() {
      await getBadgesManagement();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditHandler = () => {
    navigate(`/badges/editBadges?badgesId=${id}`);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="news-details-cls-portion">
        {isLoading && (
          <div className="set-proper-line-in-all-page">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <div className="event-details-all-starting-part">
          <div className="userprofile-pics">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Badges Details</h6>
              </div>
              <div className="right-side-btn-add d-flex align-items-center event-details-btn-cls">
                <button
                  className="btn btn-primary edit-btn-cls"
                  onClick={() => onEditHandler()}
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="news-details-all body-part-area-start-profile styling-portion-add mt-4 all-padding-side">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="title-name">
                <label>User</label>
                <div className="subtitle-names">
                  <h6 className="mb-0">
                    {serviceData?.user?.first_name +
                      " " +
                      serviceData?.user?.last_name || "-"}
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="title-name">
                <label>Title</label>
                <div className="subtitle-names">
                  <h6 className="mb-0">
                    {serviceData?.title ? serviceData?.title : "-"}
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              {/* <div className="title-name">
                <label>Type</label>
                <div className="subtitle-names">
                  <h6 className="mb-0">
                    {serviceData?.type === "1"
                      ? "Excellence"
                      : serviceData?.type === "2"
                      ? "Silver"
                      : serviceData?.type === "3"
                      ? "Gold"
                      : "-"}
                  </h6>
                </div>
              </div> */}
              <div className="title-name">
                <label>Category</label>
                <div className="subtitle-names">
                  <h6 className="mb-0">
                    {serviceData?.category === "1"
                      ? "Active Member of The Loop"
                      : serviceData?.category === "2"
                      ? "The Loop Hall of Fame Excellence Inductee"
                      : serviceData?.category === "3"
                      ? "The Loop Hall of Fame Gold Inductee"
                      : serviceData?.category === "4"
                      ? "The Loop Hall of Fame Silver Inductee"
                      : serviceData?.category === "5"
                      ? "Super Looper of the Month"
                      : serviceData?.category === "6"
                      ? "Most Popular Looper of the Month"
                      : serviceData?.category === "7"
                      ? "Happy Looper Anniversary"
                      : serviceData?.category === "8"
                      ? "Special Contributor of The Loop"
                      : serviceData?.category === "9"
                      ? "Scholar Looper"
                      : "-"}
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-lg-4">
              <div className="title-name">
                <label>Color</label>
                <div className="subtitle-names">
                  <h6 className="mb-0">
                    {serviceData?.color === 1
                      ? "Magenta"
                      : serviceData?.color === 2
                      ? "Blue"
                      : serviceData?.color === 3
                      ? "Yellow"
                      : serviceData?.color === 4
                      ? "Green"
                      : serviceData?.color === 5
                      ? "Red"
                      : serviceData?.color === 6
                      ? "Grey"
                      : serviceData?.color === 7
                      ? "Orange"
                      : serviceData?.color === 8
                      ? "Pink"
                      : serviceData?.color === 9
                      ? "Purple"
                      : "-"}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewBadges;
